<template>

<!-- We conditionally apply two new classed when hours/quota is exhauted to make sure content alignment doesn't break and the container background is changed to red -->
    <div class="transcription-duration-card-conatiner" 
         :class="[
           quotaExhausted ? 'space-between-content' : 'center-aligned-content',
           quotaExhausted ? 'warning-background' : 'default-background'
         ]">
            <div class="info-container" :style="{'flex-direction': renderedOn == 'calendar' ? 'row' : 'column'}" v-if="!quotaExhausted">
            <div v-if="showTranscriptionDuration" class="duration-info" :class="{'text-warning': transcriptionJustBelwoOneHour || noTranscriptionDuration}">
                <i class="ri-time-line primary-icon"></i>
                <span v-if="transcriptionDuration.hours > 0">{{ transcriptionDuration.hours }} hours </span> 
                <span v-if="transcriptionDuration.minutes > 0"> {{ transcriptionDuration.minutes }} mins
                </span> of transcription left {{trialEnded ? (planDuration === 'monthly' ? 'this month' : 'this year') : 'on your trial'}}
            </div>
            <template v-if="showTranscriptionDuration">
                <span v-if="renderedOn == 'calendar'" class="horizontal-divider"></span>
                <span v-else class="vertical-divider"></span>
            </template>
            <div class="upload-info" :class="{'text-warning': remainingFileUpload < 5}">
                <i class="ri-upload-cloud-2-line primary-icon"></i>
                <span>{{ remainingFileUpload }} file uploads </span>left {{trialEnded ? (planDuration === 'monthly' ? 'this month' : 'this year') : 'on your trial'}}
            </div>
        </div>
        <div v-else class="quota-exhausted-message-container">
            <h1 v-if="remainingFileUpload == 0"> <span>You’re out of uploads for {{planDuration === 'monthly' ? 'this month' : 'this year'}}.</span> <br> New files will be stored but not processed.</h1>
            <h1 v-else><span>You’re out of transcription hours for {{planDuration === 'monthly' ? 'this month' : 'this year'}}.</span> <br> New files will be stored but not transcribed.</h1>
            <button 
                class="upgrade-button"
                @click="toggleUpradePlanModal" >
                {{remainingFileUpload == 0 ? "Upgrade to get more uploads" : "Upgrade to get more hours"}}
            </button>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        showUpgradeByDefault: {
            default: true
        },
        showTranscriptionDuration: {
            default: true
        },
        renderedOn: {   //change alignment of content when rendered on calendar page:
            default: "upload_modal"
        }
    },
    computed: {
        quotaExhausted(){
            if(this.noTranscriptionDuration || this.remainingFileUpload == 0) return true
            else return false
        },
        trialEnded() {
            return this.$store.state.billingDetails.trialEnded;
        },
        planDuration(){
            return this.$store.state.billingDetails.planDuration;
        },
        transcriptionDuration(){
            return this.$store.state.remainingTranscriptionDuration;
        },
        noTranscriptionDuration(){
            let transcriptionDuration = this.$store.state.remainingTranscriptionDuration
            return transcriptionDuration.hours == 0 && transcriptionDuration.minutes < 10 
        },
        transcriptionJustBelwoOneHour(){
            let transcriptionDuration = this.$store.state.remainingTranscriptionDuration
            return transcriptionDuration.hours == 0 && transcriptionDuration.minutes >= 10 
        },
        upgradeButtonVisible(){
            if(this.transcriptionJustBelwoOneHour || this.noTranscriptionDuration || this.remainingFileUpload == 0) return true
            else if(this.showUpgradeByDefault) return true
            else return false
        },
        remainingFileUpload(){
            return this.$store.state.remainingFileUpload;
        },
    },
    methods: {
        toggleUpradePlanModal(){
            this.$store.dispatch('toggleUpgradePlanModal', true)
        }
    }
}

</script>


<style scoped>

.center-aligned-content {
    justify-content: space-around;
}

.space-between-content {
    justify-content: space-between;
}

.info-container {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.vertical-divider {
    width: 100%;
    height: 1px !important;
    background: #EDEDED;
    margin: 5px 0px;
}

.horizontal-divider {
    width: 1px !important;
    height: auto;
    background: #EDEDED;
}

.duration-info,
.upload-info {
    width: fit-content;
    display: flex;
    align-items: center;
    padding: 6px 16px;
    font-family: Inter;
    font-size: 14px;
    line-height: 21px;
    font-weight: 500;
    text-align: left;
    color: #666666;
}

.duration-info span,
.upload-info span {
    margin-right: 5px;
    font-weight: 700;
    color: #4c4c4c;

}

.duration-info i,
.upload-info i {
    font-size: 18px;
    margin-right: 5px;
    color: var(--looppanel-primary-blue);
}

.transcription-duration-card-conatiner {
    display: flex;    
    align-items: center;
    min-height: 46px;
    padding: 12px 0px;
    border-radius: 12px;
    position: relative;
    width: 100%;
    height: auto !important;
    font-family: Inter;
}

.upgrade-button {
    min-width: 215px;
    height: 34px;
    border-radius: 32px;
    background: var(--looppanel-primary-red);
    color: #fff;
    padding: 8px 20px 8px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Inter;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    text-transform: capitalize;
    /* position: absolute;
    right: 10px; */

}
.quota-exhausted-message-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0px 12px;
}

.quota-exhausted-message-container h1, .quota-exhausted-message-container span {
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    width: 90%;
    color: #C53030;
    text-align: left !important;
}

.quota-exhausted-message-container span {
    font-weight: 700;
}

.warning-background {
    background: #FFF5F5;
}

.default-background {
    background: #F8F8F8;
}

.primary-icon {
    color: currentColor;
}

.warning-button {
    background: #C53030;
}

.text-warning {
    color: #C53030 !important;
}

.text-warning i,
.text-warning span {
    color: inherit !important;
}

</style>